<template>
    <div class="survey">
            <form @submit.prevent="checkForm" action="#" method="post">

        <div class="container">
            <h3 class="section-title mt-5">{{survey.name}} - {{survey.field_params[showStep].name}}</h3>
            
            <div v-for="(section, index) in survey.field_params" v-bind:key="section.id">

                <div v-for="(card) in section.cards" v-bind:key="card.id">

                    <div v-if="showStep == index">
                        <div>
                            <div class="form-group">
                                <label for="">{{card.title}} <span v-if="card.setting.required == true">*</span></label>
                                <div v-if="card.type == 'textarea'">
                                    <textarea v-model="card.value" class="form-control"
                                        :required="card.setting.required == true"></textarea>
                                </div>
                                <div v-if="card.type == 'radio'">
                                    <div v-for="(answer,index) in card.answers" v-bind:key="answer.id" class="custom-control-inline pill-radio">
                                        <input
                                            :type="card.type"
                                            :id="answer.id"
                                            :name="card.id"
                                            :value="answer.name"
                                            class="custom-control-input"
                                            v-model="card.value"
                                            :required="card.setting.required == true && index==0"
                                        />
                                        <label class=""  :for="answer.id">
                                            {{ answer.name }}
                                        </label>
                                    </div>
                                </div>
                                <div v-if="card.type == 'checkbox'">
                                    <div v-for="answer in card.answers" v-bind:key="answer.id" class="custom-control custom-checkbox form-check-inline">
                                        <input
                                            class="custom-control-input"
                                            :name="card.id"
                                            :type="card.type"
                                            :id="answer.id"
                                            :value="answer.name"
                                            v-model="card.value"
                                            :required="card.setting.required == true" 
                                            @click="deRequireCb(card.id)"
                                        />
                                        <label
                                            class="custom-control-label"
                                            :for="answer.id"
                                        >
                                            {{ answer.name }}
                                        </label>
                                    </div>
                                </div>
                                <div v-if="card.type == 'select'">
                                    <select class="form-control custom-select" v-model="card.value" :required="card.setting.required == true">
                                        <option disabled value="">Please select one</option>
                                        <option v-for="answer in card.answers" v-bind:key="answer.id">{{answer.name}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="card.type == 'text' || card.type == 'time' || card.type == 'date'">
                                    <input class="form-control" :type="card.type" v-model="card.value"
                                        :required="card.setting.required == true">
                                </div>
                                <div v-if="card.type == 'image'">
                                    <input capture="environment" :id="card.id" type="file" @change="uploadProfileImage(card)"
                                        hidden>
                                    <label :for="card.id" class="image-upload user-photo"
                                        :class="{ 'uploaded': card.profile_image_preview }"
                                        @click="card.profile_image_preview ? clearProfileImage($event,card) : ''">
                                        <div class="btn btn-ecdc">{{ card.profile_image_preview ? 'Remove' : 'Browse' }}
                                        </div>
                                        <img v-if="card.profile_image_preview" :src="card.profile_image_preview" alt="">
                                    </label>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div v-if="showStep > 0" class="btn btn-ecdc btn-shadow" @click="showStep--">Back</div>
            <div v-if="(showStep + 1) < survey.field_params.length" class="btn btn-ecdc btn-shadow" @click="showStep++">Next</div>
            <button v-if="(showStep + 1) == survey.field_params.length" class="btn btn-ecdc btn-shadow">Submit</button>
        </div>
        
            </form>

        <app-loader v-show="isLoading"></app-loader>

    </div>

    

</template>



<script>
import { checkPermission, getPrograms, storeSurveyAnswer, getSurveyForm } from '../api'
import { getProj } from '../helpers'
import Loader from './Loader.vue'
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        appLoader: Loader
    },
    data() {
        return {
            id: this.$route.params.id,
            showStep:0,
            survey:{
                name:"Survey",
                program_id:"",
                project_id:"",
                field_params:[{
                    id:Date.now(),
                    name: "Section 1",
                    cards:[{
                    id:Date.now(),
                    title: "",
                    type:"text",
                    value:[],
                    profile_image:"",
                    profile_image_preview:"",
                    answers:[{
                        id:1,
                        name:"Option 1"
                    }],
                    setting:{
                        required:false
                    }
                    }]
                }]
            },
            programsData: "",
            defaultProject: getProj()['projId'],
            isLoading: false
        }
    },
    validations: {
        survey: {
            program_id: {
                required
            },
            name: {
                required
            }
        }
    },
    async mounted() {
        await this.getPrograms();
        await this.getSurveyForm();
    },
    methods: {
        async getSurveyForm(){

            if (this.id == 0) {
                return;
            }
            
            try {

                const result = await getSurveyForm( this.id );
                this.survey = result.data.data[0];
                console.log("survey found");

            }
            catch(err) {

                // alert(err.response.message);
                console.log("survey not found");

            }

        },
        async checkPermission(permission) {
            try {
                const result = await checkPermission({permission:permission})
                return result.data.data;
            }
            catch(err) {

                alert(err);
            }
        },
        async getPrograms() {

            try {
                const result = await getPrograms(this.defaultProject)
                this.programsData = result.data.data;
            }
            catch(err) {

                alert(err.response.data.message);
            }
        },
        async checkForm() {
            
            const _this = this;

            this.$v.survey.$touch();

            if(this.$v.survey.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() { 
                    
                    _this.isError = false;
                }, 2000);
            }
            else {

                this.isLoading = true;

                try {
                    this.survey.project_id = this.defaultProject;
                    const result = await storeSurveyAnswer(this.survey);

                    this.isSuccess = true;
                    window.scrollTo(0, 0);
                    console.log("id:"+result.data.data.id);
                }
                catch(err) {
                    console.log("id:0");
                    if (err.response) {
                        console.log(err.response.status)
                        console.log(Object.values(err.response.data).flat().join())
                    }
                }

                this.isLoading = false;
            }
        },
        deRequireCb(card_id){
            var el = document.getElementsByName(card_id);

                    var atLeastOneChecked = false; //at least one cb is checked
                    for (var i = 0; i < el.length; i++) {
                        if (el[i].checked === true) {
                            atLeastOneChecked = true;
                        }
                    }

                    if (atLeastOneChecked === true) {
                        for (i = 0; i < el.length; i++) {
                            el[i].required = false;
                        }
                    } else {
                        for (i = 0; i < el.length; i++) {
                            el[i].required = true;
                        }
                    }

        },
        uploadProfileImage(card) {
            console.log(card);
            // const _this = this;

            const files = document.getElementById(card.id).files;
            const isValid = this.validationFile(files[0]);

            if(isValid) {

                const reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onload = function() {

                    card.profile_image = reader.result;
                    card.profile_image_preview = reader.result;
                };

                reader.onerror = function(error) {

                    alert(error);
                };
            }
        },
        clearProfileImage(event,card) {

            event.preventDefault();
            card.profile_image = "";
            card.profile_image_preview = "";
            const files = document.getElementById(card.id).files;
            this.validationFile(files[0]);
        },
        validationFile(file) {
            
            if(!file.type.startsWith("image")) {

                alert("Please upload image format file.");
            }
            else if(file.size > 3145728) {
                
                alert("Please upload less than 3mb image.");
            }
            else {

                return true;
            }

            return false;
        }
    }
}
</script>